export default "__VITE_ASSET__5f763e4d__"